import { $Input } from "./styles"

export const Input = ({ type, name, value }) => {
    return (
        <$Input required type={type} name={name} value={value} />
    )
}